// eslint-disable-next-line import/no-extraneous-dependencies
import {
  FailureDomainByName
} from '@schema';

import { Module } from 'vuex';

type OccupiedFailureDomains = Record<number, Array<FailureDomainByName>>;

interface OccupiedFailureDomainsState {
  tiers: OccupiedFailureDomains,
  loading: boolean,
}

const getInitialState = (): OccupiedFailureDomainsState => ({
  tiers: {},
  loading: false,
});

export default new class implements Module<OccupiedFailureDomainsState, any> {
  name = 'occupiedFailureDomains';
  state = getInitialState();
  mutations = {
    FETCH_SUCCESS(state, data) {
      state.tiers = data;
    },
    LOADING_START(state) {
      state.loading = true;
    },
    LOADING_END(state) {
      state.loading = false;
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  };

  getters: CommonGetterTree<OccupiedFailureDomainsState> = {
    getOccupiedFailureDomains: (state): OccupiedFailureDomains => state.tiers,
  };

  actions: CommonActionTree<OccupiedFailureDomainsState> = {
    FETCH({ commit }): Promise<FetchResponse> {
      commit('LOADING_START');
      return this.$api.get('/api/v2/occupied-failure-domains/')
        .then((response) => {
          commit('FETCH_SUCCESS', response.data);
          commit('LOADING_END');
          return response;
        })
        .catch((error) => {
          commit('LOADING_END');
          throw error;
        });
    },
  };
}();
